import React, { Component } from 'react';

class TopBarDark extends Component {


    render() {
        return (
            <div className="top-header top-header-dark3" >
                <div className="container">
                       
                            <div className="header-contact text-center p-1">
                                <ul className='text-center'>
                                    <li>به ایزی کارت 724 خوش آمدید</li>
                                    {/* <li><i className="fa fa-phone" aria-hidden="true"></i>Call Us: 123 - 456 - 7890</li> */}
                                </ul>
                            </div>
                       
                </div>
            </div>
        )
    }
}


export default TopBarDark;